import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-ui-app-nodata',
  templateUrl: './ui-app-nodata.component.html',
  styleUrls: ['./ui-app-nodata.component.sass']
})
export class UiAppNodataComponent implements OnInit {
  @Input('className') className: string;
  @Input('message') msg: string;
  constructor() { }

  ngOnInit(): void {
  }

}
